import { Link as LinkIcon } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

interface Props {
  className?: string;
}

export function PlaidEmptyStateCta({ className }: Props) {
  // /settings is admin-only (FIN-52), and Plaid Link is the only thing on
  // that page right now. Hide the CTA from non-admins rather than send them
  // somewhere they'll just 403.
  const { user } = useAuth();
  if (user?.role !== "admin") return null;
  return (
    <Button asChild variant="outline" size="sm" className={className}>
      <Link to="/settings">
        <LinkIcon className="h-3.5 w-3.5" aria-hidden />
        Connect with Plaid
      </Link>
    </Button>
  );
}
